import { NavLink, Link, useLocation } from "react-router-dom";
import {
  House,
  Compass,
  PlusSquare,
  ChatCircle,
  Bell,
} from "@phosphor-icons/react";

const bottom = [
  { to: "/", icon: House, label: "Feed", end: true },
  { to: "/explorar", icon: Compass, label: "Buscar" },
  { to: "/publicar", icon: PlusSquare, label: "Publicar", cta: true },
  { to: "/mensajes", icon: ChatCircle, label: "DMs" },
  { to: "/notificaciones", icon: Bell, label: "Aviso" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#050505] border-t border-[#27272A] grid grid-cols-5"
    >
      {bottom.map((n) => {
        const Icon = n.icon;
        const active = n.end ? pathname === n.to : pathname.startsWith(n.to);
        return (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={`bottom-nav-${n.label.toLowerCase()}`}
            className={`flex flex-col items-center justify-center gap-1 py-3 ${
              n.cta
                ? "bg-[#FF3E00] text-white"
                : active
                ? "text-[#FF3E00]"
                : "text-[#A1A1AA]"
            }`}
          >
            <Icon size={22} weight={active || n.cta ? "fill" : "regular"} />
            <span className="font-mono text-[9px] uppercase tracking-[0.15em]">
              {n.label}
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
}
